/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Refresh_Aria_LabelInputs */

const en_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh tag sets`)
};

const fr_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser les ensembles de balises`)
};

const de_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag-Sets aktualisieren`)
};

const it_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna i set di tag`)
};

const ru_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить наборы тегов`)
};

const es_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar conjuntos de etiquetas`)
};

const zh_cn2_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新标签集`)
};

const ja_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグセットを更新する`)
};

const hi_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग सेट रीफ़्रेश करें`)
};

const pt_pt2_tags_refresh_aria_label = /** @type {(inputs: Tags_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar conjuntos de tags`)
};

/**
* | output |
* | --- |
* | "Refresh tag sets" |
*
* @param {Tags_Refresh_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_refresh_aria_label = /** @type {((inputs?: Tags_Refresh_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Refresh_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_refresh_aria_label(inputs)
	if (locale === "de") return de_tags_refresh_aria_label(inputs)
	if (locale === "it") return it_tags_refresh_aria_label(inputs)
	if (locale === "ru") return ru_tags_refresh_aria_label(inputs)
	if (locale === "es") return es_tags_refresh_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_refresh_aria_label(inputs)
	if (locale === "ja") return ja_tags_refresh_aria_label(inputs)
	if (locale === "hi") return hi_tags_refresh_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_refresh_aria_label(inputs)
	return en_tags_refresh_aria_label(inputs)
});